import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { GungCheckboxInputComponent } from '../gung-checkbox-input/gung-checkbox-input.component';

@Component({
    selector: 'lib-gung-checkbox-input-horizontal',
    templateUrl: './gung-checkbox-input-horizontal.component.html',
    styleUrls: ['./gung-checkbox-input-horizontal.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GungCheckboxInputHorizontalComponent),
            multi: true
        }
    ],
    standalone: false
})
export class GungCheckboxInputHorizontalComponent extends GungCheckboxInputComponent {
}
